import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from '../store';

const PAGE_SIZE = 10;

export const initialBatches = () => ({
  items: [],
  total: 0,
  pageIndex: 0,
  pageSize: PAGE_SIZE,
  pageCount: 0,
  hasMore: false,
  status: 'idle',
  loading: false,
  error: null,
});

const initialState = {
  updateBatches: initialBatches(),
  createBatches: initialBatches(),
  clearPageIndex: 0,
};

const slice = createSlice({
  name: 'batchList',
  initialState,
  reducers: {
    updateUpdateBatches(state, action) {
      state.updateBatches = action.payload;
    },

    updateCreateBatches(state, action) {
      state.createBatches = action.payload;
    },

    mergeUpdateBatches(state, action) {
      Object.assign(state.updateBatches, action.payload);
    },

    mergeCreateBatches(state, action) {
      Object.assign(state.createBatches, action.payload);
    },

    incrementUpdatePageIndex(state) {
      state.updateBatches.pageIndex += 1;
    },

    incrementCreatePageIndex(state) {
      state.createBatches.pageIndex += 1;
    },

    resetUpdatePageIndex(state) {
      state.updateBatches.pageIndex = 0;
    },

    resetCreatePageIndex(state) {
      state.createBatches.pageIndex = 0;
    },

    resetAll(state) {
      state.updateBatches = initialBatches();
      state.createBatches = initialBatches();
      state.clearPageIndex = 0;
    },
  },
});

export const {
  updateUpdateBatches,
  updateCreateBatches,
  mergeUpdateBatches,
  mergeCreateBatches,
  incrementUpdatePageIndex,
  incrementCreatePageIndex,
  resetUpdatePageIndex,
  resetCreatePageIndex,
  resetAll,
} = slice.actions;

export default slice.reducer;

export const selectUpdateBatches = (state: RootState) =>
  state.batchList.updateBatches;
export const selectCreateBatches = (state: RootState) =>
  state.batchList.createBatches;
export const selectClearPageIndex = (state: RootState) =>
  state.batchList.clearPageIndex;
